export const BRAND = {
    name: "Vistaaryatra Pvt. Ltd.",
    short: "Vistaaryatra",
    tagline: "Bespoke Domestic Tours & Travels",
};

export const CONTACT = {
    phoneDisplay: "+91 69016 83515",
    phoneHref: "tel:+916901683515",
    whatsapp:
        "https://wa.me/916901683515?text=Hello%20Vistaaryatra%2C%20I%27d%20like%20to%20plan%20a%20journey",
    email: "ashiquebhai115@gmail.com",
    emailHref: "mailto:ashiquebhai115@gmail.com",
    address: "India",
    hours: "Mon – Sat · 9:30 AM – 7:00 PM IST",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
    { label: "Home", to: "/" },
    { label: "Packages", to: "/packages" },
    { label: "About", to: "/about" },
    { label: "Gallery", to: "/gallery" },
    { label: "Contact", to: "/contact" },
];

export const DESTINATIONS = [
    "Royal Rajasthan",
    "Himachal & Shimla",
    "Kerala Backwaters",
    "Coastal Goa",
    "Kashmir Valley",
    "Andaman Islands",
    "Sacred Varanasi",
    "Uttarakhand",
    "North East India",
    "Somewhere Else",
];

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1619796696652-a29a854f21a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxpbmRpYSUyMHRyYXZlbCUyMGhpbWFsYXlhcyUyMG1vdW50YWluJTIwcGVhayUyMHN1bnNldHxlbnwwfHx8fDE3OTM4NTk5MjV8MA&ixlib=rb-4.1.0&q=85",
    rajasthanPalace:
        "https://images.unsplash.com/photo-1687372721481-be1fd4fa338d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxyYWphc3RoYW4lMjBwYWxhY2UlMjBqYWlwdXIlMjBhcmNoaXRlY3R1cmUlMjBpbmRpYXxlbnwwfHx8fDE3OTM4NTk5MjV8MA&ixlib=rb-4.1.0&q=85",
    kerala:
        "https://images.unsplash.com/photo-1593693411515-c20261bcad6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxrZXJhbGElMjBiYWNrd2F0ZXJzJTIwaG91c2UlMjBib2F0JTIwaW5kaWF8ZW58MHx8fHwxNzkzODU5OTI1fDA&ixlib=rb-4.1.0&q=85",
    goa: "https://images.unsplash.com/photo-1561571994-3c61c554181a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxnb2ElMjBiZWFjaCUyMHRyb3BpY2FsJTIwcGFsbSUyMG9jZWFuJTIwc3Vuc2V0fGVufDB8fHx8MTc5Mzg1OTkzMXww&ixlib=rb-4.1.0&q=85",
    himalaya:
        "https://images.unsplash.com/photo-1718880474770-1952b4e5f37c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxpbmRpYSUyMHRyYXZlbCUyMGhpbWFsYXlhcyUyMG1vdW50YWluJTIwcGVhayUyMHN1bnNldHxlbnwwfHx8fDE3OTM4NTk5MjV8MA&ixlib=rb-4.1.0&q=85",
    rajasthanDoorway:
        "https://images.unsplash.com/photo-1716534134003-ba47907e119b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxyYWphc3RoYW4lMjBwYWxhY2UlMjBhcmNoaXRlY3R1cmUlMjBpbmRpYXxlbnwwfHx8fDE3OTM4NTk5MjV8MA&ixlib=rb-4.1.0&q=85",
    udaipurGolden:
        "https://images.unsplash.com/photo-1695956353120-54ce5e91632b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHx1ZGFpcHVyJTIwbGFrZSUyMHBhbGFjZSUyMGluZGlhfGVufDB8fHx8MTc5Mzg2MDEyM3ww&ixlib=rb-4.1.0&q=85",
    udaipurPalace:
        "https://images.unsplash.com/photo-1589901164570-f9de6556e1c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHx1ZGFpcHVyJTIwbGFrZSUyMHBhbGFjZSUyMGluZGlhfGVufDB8fHx8MTc5Mzg2MDEyM3ww&ixlib=rb-4.1.0&q=85",
    varanasiGhats:
        "https://images.unsplash.com/photo-1561359313-0639aad49ca6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHx2YXJhbmFzaSUyMGdhbmdlcyUyMGdoYXRzJTIwYm9hdHN8ZW58MHx8fHwxNzkzODYwMTIzfDA&ixlib=rb-4.1.0&q=85",
    varanasiDawn:
        "https://images.unsplash.com/photo-1561361058-c24cecae35ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHx2YXJhbmFzaSUyMGdhbmdlcyUyMGdoYXRzJTIwYm9hdHN8ZW58MHx8fHwxNzkzODYwMTIzfDA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
    "Expeditions",
    "Heritage Palaces",
    "Himalayan Trails",
    "Backwater Cruises",
    "Royal Safaris",
    "Bespoke Itineraries",
];
